import { ParameterType } from '@/study-search/enums';

import { FilterOptionInformation, FormatFilterOptionValue } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';

class DistanceLearningFormatFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.ATTENDANCE,
			[
				new FilterOptionInformation('Full-time', FormatFilterOptionValue.FULL_TIME, '', ''),
				new FilterOptionInformation('Part-time', FormatFilterOptionValue.PART_TIME, 'part-time', 'Part-time')
			],
			[FormatFilterOptionValue.PART_TIME]
		);
	}
}

export default new DistanceLearningFormatFilterDefinition();
